import { css } from '@emotion/css';
import { Theme } from '@mui/material';

export const useAccountMenuStyles = (theme: Theme, selectedTheme: number) => {
  const invertedTheme = selectedTheme === 8;

  return {
    menuList: css({
      '& .menu-item': {},
    }),
    avatar: css({
      '&.MuiAvatar-root': {
        color: invertedTheme ? theme.palette.secondary.light : theme.palette.primary.contrastText,
        backgroundColor: invertedTheme
          ? theme.palette.secondary.contrastText
          : theme.palette.secondary.dark,
        width: 32,
        height: 32,
        margin: 0,
        fontSize: 12,
      },
    }),
    userName: css({}),
    text: css({
      whiteSpace: 'nowrap',

      '&.MuiTypography-subtitle1': {
        color: theme.palette.grey['A700'],
      },
    }),
    iconRoot: css({
      position: 'static',
    }),
    iconText: css({
      color: theme.palette.grey['500'],
    }),
    iconBackGround: css({
      fontSize: '2rem',
    }),
    menuItem: css({
      '&.menu-item': {
        minWidth: 150,
      },
      '& .MuiTypography-subtitle1': {
        color: theme.palette.grey['A700'],
        fontSize: 18,
      },
      '& .MuiListItemIcon-root': {
        color: theme.palette.grey['A700'],
        marginRight: theme.spacing(1),
        fontSize: '1.75rem',
        justifyContent: 'center',
      },
    }),
  };
};
